import React from 'react';

import ListingImageMosaic from './ListingImageMosaic/ListingImageMosaic';

import css from './ListingPage.module.css';

/**
 * Listing image gallery — Figma mosaic layout.
 *
 * @component
 */
const SectionGallery = props => {
  const { listing, onManageDisableScrolling } = props;
  const images = listing.images || [];

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageMosaic images={images} onManageDisableScrolling={onManageDisableScrolling} />
    </section>
  );
};

export default SectionGallery;
